<script>
	import formBase from '@_system/components/base/form.vue'
	import bankaccbox from './box/bankacc.vue'
	import rcvaccbox from './box/rcvacc.vue'
	import yhzzdform from '@/components/forms/transferaccounts/jindie/yhzzdform.vue'
	import xjzzdform from '@/components/forms/transferaccounts/jindie/xjzzdform.vue'
	import xjcqdform from '@/components/forms/transferaccounts/jindie/xjcqdform.vue'
	import fkdform from '@/components/forms/transferaccounts/jindie/fkdform.vue'
	import fktkdform from '@/components/forms/transferaccounts/jindie/fktkdform.vue'
	import skdform from '@/components/forms/transferaccounts/jindie/skdform.vue'
	
	
	export default {
		extends: formBase,
		name: 'formaltransferaccountForm',
		props: {

		},
		data() {
			return {
				maindata:[],
				tabledata:[],
				jindierequire:null
			}

		},
		render(h) {
			this.$slots.plug = [
				<bankaccbox ref = "bankaccbox" onBack = {this.bankaccboxBack}
					onSubmit = {this.bankaccboxSubmit}
					onBoxdataload = {this.bankaccboxload}/>,
				<rcvaccbox ref = "rcvaccbox" onBack = {this.rcvaccboxBack}
					onSubmit = {this.rcvaccboxSubmit}
					onBoxdataload = {this.rcvaccboxload} costobj = {this.costobj} businessstaffid={this.businessstaffid} />,	
				<yhzzdform ref = "yhzzdform" maindata={this.maindata} tabledata={this.tabledata} jindierequire={this.jindierequire} onSuccess={this.jindieformSuccess} onClear={this.jindieformClear} />,
				<xjzzdform ref = "xjzzdform" maindata={this.maindata} tabledata={this.tabledata} jindierequire={this.jindierequire} onSuccess={this.jindieformSuccess} onClear={this.jindieformClear} />,	
				<xjcqdform ref = "xjcqdform" maindata={this.maindata} tabledata={this.tabledata} jindierequire={this.jindierequire} onSuccess={this.jindieformSuccess} onClear={this.jindieformClear} />,	
				
				<fkdform ref = "fkdform" maindata={this.maindata} tabledata={this.tabledata} jindierequire={this.jindierequire} onSuccess={this.jindieformSuccess} onClear={this.jindieformClear} />,
				<fktkdform ref = "fktkdform" maindata={this.maindata} tabledata={this.tabledata} jindierequire={this.jindierequire} onSuccess={this.jindieformSuccess} onClear={this.jindieformClear} />,
				
				<skdform ref = "skdform" maindata={this.maindata} tabledata={this.tabledata} jindierequire={this.jindierequire} onSuccess={this.jindieformSuccess} onClear={this.jindieformClear} />,
					
			]
			return formBase.render.call(this, h)
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			beforeSubmit(formData, next){
				formData.jindierequire = formData.jindierequire?JSON.parse(formData.jindierequire):null
				next()
			},
			beforeRender(sourceData) {
				sourceData.jindierequire = sourceData.jindierequire?JSON.stringify(sourceData.jindierequire):null
			},
			jindieformSuccess(e){
				this.fApi.setValue('jindierequire',e.data)
				this.fApi.setValue('jindiestaffid',this.$store.state.system.user.id)
			},
			jindieformClear(){
				this.fApi.setValue('jindierequire',null)
			},
			jindierequireButton(){
				let jindietype = this.fApi.getValue('jindietype')
				if(!jindietype){
					this.$message.error('请选择星空模块')
					return
				}
				let maindata = {}
				maindata.payAcc = this.fApi.getValue('payacc')
				maindata.rcvAcc = this.fApi.getValue('rcvacc')
				maindata.mark = this.fApi.getValue('mark')
				maindata.jindietype = jindietype
				maindata.amount = this.fApi.getValue('amount')
				this.maindata = maindata
				let jindiedetail = {
					FEXPENSEDEPTID_E:null,
					FCOSTID:null,
					FSETTLETYPEID:null,
					FPURPOSEID:null,
					F_SXTN_DFKM:null,
					F_SXTN_ZZJG:null,
				}
				if(maindata.jindietype == 'AP_PAYBILL'){
					jindiedetail.FPAYTOTALAMOUNTFOR = maindata.amount
					jindiedetail.FPAYAMOUNTFOR_E = maindata.amount
				}
				if(maindata.jindietype == 'AP_REFUNDBILL'){
					jindiedetail.FREFUNDAMOUNTFOR = maindata.amount
					jindiedetail.FREFUNDAMOUNTFOR_E = maindata.amount
				}
				this.tabledata = [jindiedetail]
				this.jindierequire = this.fApi.getValue('jindierequire')
				this.$nextTick(()=>{
					if(jindietype == 'CN_BANKTRANSBILL'){
						this.$refs.yhzzdform.modal_show()
					}
					if(jindietype == 'CN_CASHTRANSBILL'){
						this.$refs.xjzzdform.modal_show()
					}
					if(jindietype == 'CN_CASHACCESSBILL'){
						this.$refs.xjcqdform.modal_show()
					}
					if(jindietype == 'AP_PAYBILL'){
						this.$refs.fkdform.modal_show()
					}
					if(jindietype == 'AP_REFUNDBILL'){
						this.$refs.fktkdform.modal_show()
					}
					if(jindietype == 'AR_RECEIVEBILL'){
						this.$refs.skdform.modal_show()
					}
				})				
			},
			jindietypeChange(){
				this.fApi.setValue('jindierequire',null)
			},
			
			paycodeButton(){
				this.$refs.bankaccbox.initList()
				this.$refs.bankaccbox.box.alertBox()
			},
			rcvcodeButton(){
				this.$refs.rcvaccbox.initList()
				this.$refs.rcvaccbox.box.alertBox()		
			},
			bankaccboxBack(){
				
			},
			bankaccboxSubmit(e){
				if(e.data){
					this.fApi.setValue('paycode',e.data.acc_code)
					this.fApi.setValue('payaccName',e.data.acc_name)
					this.fApi.setValue('payacc',e.data.inst_account)
				}
			},
			bankaccboxload(){
				
			},
			rcvaccboxBack(){
				
			},
			rcvaccboxSubmit(e){
				if(e.data){
					this.fApi.setValue('rcvcode',e.data.acc_code)
					this.fApi.setValue('rcvaccName',e.data.acc_name)
					this.fApi.setValue('rcvacc',e.data.inst_account)
				}
			},
			rcvaccboxload(){
				
			},
			beforeInit(next){
				next()
			}
		},
		components: {

		}
	}
</script>
